import { render, staticRenderFns } from "./Accountmismatch.vue?vue&type=template&id=78a56f27&scoped=true"
import script from "./Accountmismatch.vue?vue&type=script&lang=js"
export * from "./Accountmismatch.vue?vue&type=script&lang=js"
import style0 from "./Accountmismatch.vue?vue&type=style&index=0&id=78a56f27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a56f27",
  null
  
)

export default component.exports